// TSS vite/02 — centralized constants.
// Rendered by the FAQ section and serialized as FAQPage structured data;
// both must show the exact same text or Google ignores the markup.

export const FAQS = [
    {
        question: '¿Trabajan con medios pequeños o que apenas están empezando?',
        answer: 'Sí. Acompañamos desde proyectos que están naciendo hasta medios y marcas consolidadas. Ajustamos el alcance a tu etapa, tus objetivos y tu presupuesto.',
    },
    {
        question: '¿Puedo contratar un solo servicio?',
        answer: 'Claro. Puedes tomar solo asesoría, solo producción audiovisual o solo desarrollo web. Si lo necesitas, integramos varios servicios en un mismo plan para que todo funcione en conjunto.',
    },
    {
        question: '¿Cómo es el proceso para cotizar un proyecto?',
        answer: 'Nos cuentas tu necesidad en el formulario, agendamos una conversación para entender tu medio y te enviamos una propuesta con alcance, tiempos y valor de inversión.',
    },
    {
        question: '¿Qué incluye el acompañamiento estratégico?',
        answer: 'Incluye el diagnóstico de tus canales, la definición de modelos de monetización, la planeación de contenidos y una hoja de ruta de crecimiento con seguimiento periódico.',
    },
    {
        question: '¿Desarrollan portales de noticias y plataformas de streaming?',
        answer: 'Sí. Diseñamos y desarrollamos portales de noticias, sitios corporativos de alta velocidad, plataformas de streaming y landing pages de captación, optimizados para SEO y para dispositivos móviles.',
    },
    {
        question: '¿Atienden clientes fuera de su ciudad?',
        answer: 'Sí. Buena parte de la asesoría, el marketing y el desarrollo se realiza de forma remota. Para producciones en sitio coordinamos la logística según cada proyecto.',
    },
];
